function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 52,
  height: 52,
  rx: 8,
  fill: "#FEEEEA"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.425 28.025L31.85 20.6L29.7125 18.4625L24.425 23.75L22.325 21.65L20.1875 23.7875L24.425 28.025ZM26 37.025C29.05 34.225 31.3125 31.681 32.7875 29.393C34.2625 27.106 35 25.075 35 23.3C35 20.575 34.131 18.3435 32.393 16.6055C30.656 14.8685 28.525 14 26 14C23.475 14 21.3435 14.8685 19.6055 16.6055C17.8685 18.3435 17 20.575 17 23.3C17 25.075 17.7375 27.106 19.2125 29.393C20.6875 31.681 22.95 34.225 26 37.025ZM26 41C21.975 37.575 18.969 34.3935 16.982 31.4555C14.994 28.5185 14 25.8 14 23.3C14 19.55 15.2065 16.5625 17.6195 14.3375C20.0315 12.1125 22.825 11 26 11C29.175 11 31.9685 12.1125 34.3805 14.3375C36.7935 16.5625 38 19.55 38 23.3C38 25.8 37.0065 28.5185 35.0195 31.4555C33.0315 34.3935 30.025 37.575 26 41Z",
  fill: "#F2512D"
});

function SvgStepInfo2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepInfo2);
export default __webpack_public_path__ + "static/media/step_info_2.35cc5ab7.svg";
export { ForwardRef as ReactComponent };